import React from "react";
import { Box, Typography } from "@mui/material";
import { METRIC_THRESHOLDS } from "../../constants/airQuality";

/** Legenda delle fasce di una grandezza, in basso a sinistra sulla mappa, come negli Open Data. */
export default function EnvironmentLegend({ metricKey, metricLabel, unit }) {
    const thresholds = METRIC_THRESHOLDS[metricKey];
    if (!thresholds) return null;
    return (
        <Box
            sx={{
                position: "absolute",
                left: 8,
                bottom: 8,
                bgcolor: "rgba(255,255,255,0.9)",
                borderRadius: 1,
                boxShadow: 3,
                p: 1,
                fontSize: 12,
                maxWidth: 260,
                zIndex: 2,
            }}
        >
            <Typography variant="caption" sx={{ fontWeight: 600, display: "block", mb: 0.5 }}>
                {metricLabel}
            </Typography>
            {thresholds.map((thr, idx) => (
                <Box key={idx} sx={{ display: "flex", alignItems: "center", mb: 0.25 }}>
                    <Box sx={{ width: 14, height: 14, mr: 0.75, bgcolor: thr.color, border: "1px solid #ccc" }} />
                    <span>
                        {thr.min} - {thr.max}
                        {unit ? ` ${unit}` : ""}
                    </span>
                </Box>
            ))}
        </Box>
    );
}
